import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type { UpdateUserPreferencesInput, UserPreferencesResponse } from "@/lib/types";

import { fetchUserPreferences, updateUserPreferences } from "@/lib/api";

const PREFERENCES_QUERY_KEY = ["me", "preferences"] as const;

export function usePreferences() {
  return useQuery({
    queryKey: PREFERENCES_QUERY_KEY,
    queryFn: fetchUserPreferences,
    staleTime: 60 * 1000,
  });
}

export function useUpdatePreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateUserPreferencesInput) => updateUserPreferences(data),
    onSuccess: (result: UserPreferencesResponse) => {
      queryClient.setQueryData(PREFERENCES_QUERY_KEY, result);
    },
  });
}
